

export default {
	testToKen:(state:any)=>state.testToken,
	token:(state:any)=>state.token
}